/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import { GraphicHandlerWithWorker } from '../util/graphicHandler.js'
import {
    EventStateHandler,
    EventRecordManager,
} from '../util/eventRecordManager.js'

import { scaleVideoToCanvasCenterAndKeepRatio } from '../helpers/utils'

import '../styles/cameraStream.scss'
import { FormattedMessage } from 'react-intl'
import SnapshotManager from '../util/snapshotManager'
import { LinearProgress } from '@material-ui/core'
import CameraControls from './CameraControls'
import UserAlert from '../containers/UserAlert'

export default class CameraStream extends React.Component {
    constructor(props) {
        super(props)

        this.videoEle = React.createRef()
        this.canvasContainerEle = React.createRef()
        this.canvasScaledContainerEle = React.createRef()

        this.previewCanvasEle = React.createRef()
        this.mainCanvasEle = React.createRef()
        this.boxCanvasEle = React.createRef()
        this.videoCanvasEle = React.createRef()

        // live and recording would be in different reslotion
        this.recordingCanvasEle = React.createRef()

        this.windowResizeListener = null

        this.state = {
            scaledWidth: 0,
            scaledHeight: 0,
            progressValue: 0,
        }
    }

    _setProgressTimer() {
        this.timer = setInterval(() => {
            const { progressValue } = this.state
            if (progressValue >= this.maxProgressValue) {
                clearInterval(this.timer)
                this.timer = null
            } else if (this.graphicHandler) {
                if (this.graphicHandler.state == 'start') {
                    this.setState({
                        progressValue: Math.max(100, progressValue + 1),
                    })
                }
            } else if (progressValue < 95) {
                this.setState({
                    progressValue: Math.min(
                        95,
                        progressValue + Math.round(Math.random() * 5)
                    ),
                })
            }
        }, 800)
    }

    async componentDidMount() {
        await this.bindStreamToVideo()
        this.maxProgressValue = 102
    }

    async bindStreamToVideo() {
        const {
            sourceStream,
            videoRatio,

            isMotionDetection,
            isPersonDetection,
            isPersonDetectionBox,
            isAutoLowLight,
            isNightVision,
            sensitivity,

            isFree,
            isZoom,
            recordNativeResolution,
            testVideo,
        } = this.props

        const video = this.videoEle.current
        const canvasContainer = this.canvasContainerEle.current
        const canvasScaledContainer = this.canvasScaledContainerEle.current
        const boxCanvas = this.boxCanvasEle.current
        const videoCanvas = this.videoCanvasEle.current
        const mainCanvas = this.mainCanvasEle.current
        const previewCanvas = this.previewCanvasEle.current
        const recordCanvas = this.recordingCanvasEle.current

        const canvasSizeToMaxList = [previewCanvas, boxCanvas]
        const handleWindowResize = this.handleWindowResize.bind(this, {
            video,
            canvasContainer,
            canvasScaledContainer,
            canvasSizeToMaxList,
            videoRatio,
        })
        handleWindowResize()

        if (!sourceStream) {
            return
        }

        if (this.graphicHandler) {
            // stop extracting frames from video when changing srcObject
            this.graphicHandler.stop()
            this.graphicHandler = null
        }

        const isPlaying =
            video.currentTime > 0 &&
            !video.paused &&
            !video.ended &&
            video.readyState > 2

        try {
            if (isPlaying) {
                video.pause()
                video.srcObject = null
            }
        } catch (error) {}

        // change resolution due to spec
        const {
            previewWidth,
            previewHeight,
            liveWidth,
            liveHeight,
        } = this.props.cameraContext
        mainCanvas.width = liveWidth
        mainCanvas.height = liveHeight
        videoCanvas.width = previewWidth
        videoCanvas.height = previewHeight

        if (recordNativeResolution) {
            // Force to record native resolution for testing.
            recordCanvas.width = previewWidth
            recordCanvas.height = previewHeight
        } else {
            // Production logit
            if (isFree || previewWidth === 1280) {
                recordCanvas.width = Number.parseInt(previewWidth / 2)
                recordCanvas.height = Number.parseInt(previewHeight / 2)
            } else {
                recordCanvas.width = previewWidth
                recordCanvas.height = previewHeight
            }
        }

        // video.srcObject = sourceStream
        if (testVideo instanceof File) {
            video.pause()
            video.srcObject = null
            video.src = null

            const video_url = URL.createObjectURL(testVideo)
            video.src = video_url
            video.loop = true
            video.muted = true
            video.autoplay = true
        } else {
            video.srcObject = sourceStream
        }

        this.windowResizeListener = window.addEventListener(
            'resize',
            handleWindowResize
        )

        const liveTracks = [mainCanvas.captureStream(15).getVideoTracks()[0]]
        let audioTrack = sourceStream.getAudioTracks()[0]

        // make sure microphone exists
        if (audioTrack) {
            liveTracks.push(audioTrack)
        }

        if (this.eventStateHandler) {
            this.eventStateHandler.tick('interrupte')
            this.eventStateHandler = null
        }

        if (!this.props.pureStream) {
            const liveStream = new MediaStream(liveTracks)
            this.props.cameraContext.mutations.updateStatus({
                mainCanvas,
                recordCanvas,
                liveStream,
            })
            const recordManager = new EventRecordManager({
                record_canvas: recordCanvas,
                sourceStream,
                frame_width: recordCanvas.width,
                frame_height: recordCanvas.height,
                isFree,
            })
            const snapshotManager = SnapshotManager.getInstance()
            this.eventStateHandler = new EventStateHandler(
                recordManager,
                this.props.deviceContext.mutations.createEventWithSnapshot,
                this.props.deviceContext.mutations.onCreateEventSuccess,
                this.props.deviceContext.mutations.onMotionDetected,
                this.props.deviceContext.mutations.attachVideoToEvent,
                snapshotManager.generateSnapshotForEvent.bind(snapshotManager, {
                    video_or_canvas: mainCanvas,
                    isFree,
                }),
                this.props.cameraContext.mutations.updateStatus
            )
        }

        if (!this.graphicHandler) {
            this.graphicHandler = new GraphicHandlerWithWorker({
                video,
                videoCanvas,
                boxCanvas,
                previewCanvas,
                mainCanvas,
                recordCanvas,
                handleWindowResize,
                eventStateHandler: this.eventStateHandler,

                isMotionDetection,
                isPersonDetection,
                isPersonDetectionBox,
                isAutoLowLight,
                isNightVision,
                sensitivity,
                isFree,
                deviceContext: this.props.deviceContext,
            })
            this.graphicListener = () => {
                try {
                    if (this.graphicHandler.state != 'start') {
                        this.setState({ progressValue: 0 })
                        this._setProgressTimer()
                        this.graphicHandler.start((progress) => {
                            console.log('progress: ', progress)
                            this.setState({
                                progressValue: Math.max(
                                    progress,
                                    this.state.progressValue
                                ),
                            })
                        })
                    }
                } catch (error) {
                    // When looping through test video, we will trigger playing event multiple times
                    if (!video.loop) throw error
                }

                if (isZoom) {
                    this.handleZoom()
                }
            }
            video.addEventListener('playing', this.graphicListener)
        } else {
            // this.graphicHandler.start()
            this.graphicHandler.eventStateHandler = this.eventStateHandler
            this.graphicListener = () => {
                this.graphicHandler.start()
            }
            video.oncanplay = this.graphicListener
        }

        try {
            await video.play()
        } catch (error) {
            console.error('source stream video: ', error)
        }
    }

    async componentDidUpdate(prevProps) {
        if (
            prevProps.cameraContext.isPreview !==
            this.props.cameraContext.isPreview
        ) {
            if (!this.props.isPreview) {
                if (this.eventStateHandler) {
                    this.eventStateHandler.tick('interrupte')
                }
                this.cleanUpEvents()
                this.stopSourceStream()
            }
        }

        if (
            prevProps.cameraContext.liveWidth !==
            this.props.cameraContext.liveWidth
        ) {
            const { sourceStream } = this.props
            if (sourceStream) {
                const mainCanvas = this.mainCanvasEle.current
                mainCanvas.width = this.props.cameraContext.liveWidth
                mainCanvas.height = this.props.cameraContext.liveHeight

                const liveTracks = [
                    mainCanvas.captureStream(15).getVideoTracks()[0],
                ]

                // make sure microphone exists
                if (sourceStream.getAudioTracks()[0]) {
                    liveTracks.push(sourceStream.getAudioTracks()[0])
                }

                const liveStream = new MediaStream(liveTracks)
                this.props.cameraContext.mutations.updateStatus({ liveStream })
            }
        }
        if (this.graphicHandler) {
            if (
                prevProps['isZoom'] !== this.props['isZoom'] ||
                prevProps['clickX'] !== this.props['clickX'] ||
                prevProps['clickY'] !== this.props['clickY'] ||
                prevProps['zoomScale'] !== this.props['zoomScale']
            ) {
                this.handleZoom()
            }
            if (prevProps['sensitivity'] !== this.props['sensitivity']) {
                if (this.props.isMotionDetection) {
                    this.graphicHandler.send_input_event(
                        'setMotionThreshold',
                        this.props['sensitivity']
                    )
                }
                if (this.props.isPersonDetection) {
                    this.graphicHandler.send_input_event(
                        'setPersonThreshold',
                        this.props['sensitivity']
                    )
                }
            }

            if (
                prevProps['isAutoLowLight'] !== this.props['isAutoLowLight'] ||
                prevProps['isNightVision'] !== this.props['isNightVision']
            ) {
                if (this.props['isAutoLowLight'] === true) {
                    this.graphicHandler.send_input_event('isAutoLowLight', true)
                } else {
                    this.graphicHandler.send_input_event(
                        'isAutoLowLight',
                        false
                    )
                    if (prevProps['isAutoLowLight'] === true) {
                        this.graphicHandler.send_input_event(
                            'isNightVision',
                            false
                        )
                    } else {
                        this.graphicHandler.send_input_event(
                            'isNightVision',
                            this.props['isNightVision']
                        )
                    }
                }
            }

            if (
                prevProps['globalInfereceInterval'] !==
                this.props['globalInfereceInterval']
            ) {
                this.graphicHandler.send_input_event(
                    'setGlobalInfereceInterval',
                    this.props['globalInfereceInterval']
                )
            }

            if (prevProps['debugView'] !== this.props['debugView']) {
                this.graphicHandler.send_input_event(
                    'setDebugView',
                    this.props['debugView']
                )
            }
            if (prevProps['runPipeline'] !== this.props['runPipeline']) {
                if (this.props['runPipeline']) this.graphicHandler.start()
                else this.graphicHandler.pause()
            }
            if (
                prevProps.imConnectionContext.liveCounter !=
                this.props.imConnectionContext.liveCounter
            ) {
                if (this.graphicHandler) {
                    this.graphicHandler.send_input_event(
                        'liveCount',
                        this.props.imConnectionContext.liveCounter
                    )
                }
            }

            if (prevProps['dbFile'] !== this.props['dbFile']) {
                if (this.props['dbFile'] instanceof File) {
                    console.log('Import!!!!!')
                    this.graphicHandler.embed_db.import_db(this.props['dbFile'])
                } else {
                    console.log('EXPORT!!!!!')
                    this.graphicHandler.embed_db.export_db()
                }
            }
            if (prevProps['testImage'] !== this.props['testImage']) {
                if (this.props['testImage'] instanceof File) {
                    console.log('Import Image !!!!!')
                    let test_img_bitmap = await createImageBitmap(
                        this.props['testImage'],
                        {
                            resizeWidth: 1280,
                            resizeHeight: 960,
                        }
                    )
                    this.graphicHandler.video_canvas
                        .getContext('2d')
                        .drawImage(
                            test_img_bitmap,
                            0,
                            0,
                            this.graphicHandler.video_canvas.width,
                            this.graphicHandler.video_canvas.height
                        )
                    this.graphicHandler.vis_pipeline.send_input_frame(undefined)
                } else {
                    console.log('EXPORT !!!!!')
                }
            }
        }

        const pipeline_options = [
            'isPersonDetection',
            'isMotionDetection',
            'isPersonDetectionBox',
        ]
        const opt_signal_map = {
            isPersonDetection: 'isPersonDetection',
            isMotionDetection: 'isMotionDetection',
            isPersonDetectionBox: 'isPersonDetectionBox',
        }
        for (const opt of pipeline_options) {
            if (prevProps[opt] !== this.props[opt]) {
                this.graphicHandler.send_input_event(
                    opt_signal_map[opt],
                    this.props[opt]
                )
            }
        }

        if (prevProps.sourceStream !== this.props.sourceStream) {
            if (this.eventStateHandler) {
                this.eventStateHandler.tick('interrupte')
            }
            this.cleanUpEvents()
            await this.bindStreamToVideo()
        }

        if (
            prevProps.recordNativeResolution !==
            this.props.recordNativeResolution
        ) {
            if (this.eventStateHandler) {
                this.eventStateHandler.tick('interrupte')
            }
            this.cleanUpEvents()
            await this.bindStreamToVideo()
        }

        if (prevProps.testVideo !== this.props.testVideo) {
            if (this.eventStateHandler) {
                this.eventStateHandler.tick('interrupte')
            }
            this.cleanUpEvents()
            await this.bindStreamToVideo()
        }

        // if offline, stop detection
        if (
            prevProps.imConnectionContext.status !==
            this.props.imConnectionContext.status
        ) {
            if (this.props.imConnectionContext.status === 'online') {
                if (this.graphicHandler) {
                    if (this.props.isPersonDetection) {
                        this.graphicHandler.send_input_event(
                            'isPersonDetection',
                            this.props.isPersonDetection
                        )
                        this.graphicHandler.send_input_event(
                            'isMotionDetection',
                            true
                        )
                        // NOTE: You need motion to trigger person detection
                    } else {
                        this.graphicHandler.send_input_event(
                            'isPersonDetection',
                            this.props.isPersonDetection
                        )
                        this.graphicHandler.send_input_event(
                            'isMotionDetection',
                            this.props.isMotionDetection
                        )
                    }
                }
            }
            if (this.props.imConnectionContext.status === 'offline') {
                if (this.graphicHandler) {
                    this.graphicHandler.send_input_event(
                        'isPersonDetection',
                        false
                    )
                    this.graphicHandler.send_input_event(
                        'isMotionDetection',
                        false
                    )
                }
                if (this.eventStateHandler) {
                    this.eventStateHandler.tick('interrupte')
                }
            }
        }
    }

    handleZoom() {
        if (this.props.isZoom === false) {
            return this.graphicHandler.send_input_event('ZoomOut')
        } else {
            if (this.props['zoomMode'] == 2) {
                this.graphicHandler.send_input_event('Zoom2', {
                    x: this.props.clickX,
                    y: this.props.clickY,
                    scale: this.props.zoomScale,
                })
            } else if (this.props['zoomMode'] == 1) {
                this.graphicHandler.send_input_event('ZoomByClick', {
                    clickX: this.props.clickX,
                    clickY: this.props.clickY,
                })
            } else {
                throw Error(`Unknow zoom-in mode ${this.props['zoomMode']}!`)
            }
        }
    }

    componentWillUnmount() {
        this.cleanUpEvents()
        if (this.timer) {
            clearInterval(this.timer)
        }
        if (!this.props.pureStream) {
            this.stopSourceStream()
        } else {
            if (this.graphicHandler) {
                this.graphicHandler.stop()
                this.graphicHandler = null
            }
        }
        window.removeEventListener('resize', this.windowResizeListener)
        this.windowResizeListener = null
    }

    cleanUpEvents() {
        const video = this.videoEle.current
        video.removeEventListener('playing', this.graphicListener)
    }

    stopSourceStream() {
        if (this.props.sourceStream) {
            const tracks = this.props.sourceStream.getTracks()

            tracks.forEach(function (track) {
                track.stop()
            })
        }
        if (this.graphicHandler) {
            this.graphicHandler.stop()
            this.graphicHandler = null
        }

        const previewCanvas = this.previewCanvasEle.current
        const context = previewCanvas.getContext('2d')
        context.clearRect(0, 0, previewCanvas.width, previewCanvas.height)
    }

    initialVideoSize({ canvasContainer, videoRatio = false }) {
        const canvasWidth = canvasContainer.clientWidth
        const canvasHeight = canvasContainer.clientHeight
        let videoWidth = 0
        let videoHeight = 0
        let aspectRatio = videoRatio ? 16 / 9 : 4 / 3
        let reciprocal = videoRatio ? 9 / 16 : 3 / 4
        if (canvasWidth / canvasHeight > aspectRatio) {
            videoHeight = canvasHeight
            videoWidth = videoHeight * aspectRatio
        } else {
            videoWidth = canvasWidth
            videoHeight = videoWidth * reciprocal
        }
        return {
            videoWidth,
            videoHeight,
        }
    }

    handleWindowResize({
        video,
        videoRatio,
        canvasContainer,
        canvasScaledContainer,
        canvasSizeToMaxList,
    }) {
        let videoWidth = video.videoWidth
        let videoHeight = video.videoHeight

        if (videoWidth === 0) {
            ;({ videoWidth, videoHeight } = this.initialVideoSize({
                canvasContainer,
                videoRatio,
            }))
        }
        let {
            scaledWidth,
            scaledHeight,
            videoPosY,
            videoPosX,
        } = scaleVideoToCanvasCenterAndKeepRatio({
            videoWidth,
            videoHeight,
            canvasWidth: canvasContainer.clientWidth,
            canvasHeight: canvasContainer.clientHeight,
        })

        scaledWidth = Math.round(scaledWidth)
        scaledHeight = Math.round(scaledHeight)

        canvasScaledContainer.style.width = `${scaledWidth}px`
        canvasScaledContainer.style.height = `${scaledHeight}px`
        canvasScaledContainer.style.left = `${videoPosX}px`
        canvasScaledContainer.style.top = `${videoPosY}px`

        canvasSizeToMaxList.forEach((canvas) => {
            if (canvas.width != scaledWidth) canvas.width = scaledWidth
            if (canvas.height != scaledHeight) canvas.height = scaledHeight
        })

        if (
            this.state.scaledWidth != scaledWidth ||
            this.state.scaledHeight != scaledHeight
        ) {
            this.setState({
                scaledWidth,
                scaledHeight,
                videoPosY,
                videoPosX,
            })
        }
    }

    /*  ui  */
    showCameraStats() {
        const { isRecording, recordTime } = this.props

        const { liveCounter, status } = this.props.imConnectionContext

        const { isAudio } = this.props.cameraContext

        let labelList = []

        if (liveCounter > 0) {
            labelList.push(
                <div key="live" className="camera-status camera-status_warning">
                    <FormattedMessage id="Live" />
                </div>
            )
        } else {
            if (status === 'online') {
                labelList.push(
                    <div
                        key="online"
                        className="camera-status camera-status_online"
                    >
                        <FormattedMessage id="Online" />
                    </div>
                )
            } else if (status === 'offline') {
                labelList.push(
                    <div
                        key="offline"
                        className="camera-status camera-status_warning"
                    >
                        <FormattedMessage id="Offline" />
                    </div>
                )
            } else if (status === 'connecting') {
                labelList.push(
                    <div
                        key="connecting"
                        className="camera-status camera-status_warning"
                    >
                        <FormattedMessage id="Connecting" />
                    </div>
                )
            }
        }

        if (isRecording) {
            labelList.push(
                <div key="rec" className="camera-status camera-status_warning">
                    <span className="recording-spot"> </span> REC {recordTime}
                </div>
            )
        }

        if (!isAudio) {
            labelList.push(
                <div key="audioOff" className="camera-status camera-status_off">
                    <FormattedMessage id="AudioOff" />
                </div>
            )
        }

        return <div className="camera-status__container">{labelList}</div>
    }

    printScreenSize() {
        const { sourceStream } = this.props

        if (!sourceStream) {
            return
        }
        const {
            previewWidth,
            previewHeight,
            liveWidth,
            liveHeight,
        } = this.props.cameraContext

        return (
            <div className="screen-size-panel">
                <p className="screen-size-panel__text">
                    preview resolution: {previewWidth} x {previewHeight}
                </p>
                <p className="screen-size-panel__text">
                    live resolution: {liveWidth} x {liveHeight}
                </p>
            </div>
        )
    }

    handleZoomClick(event) {
        /* create zoom event */
        const {
            mutations: { updateStatus },
        } = this.props.cameraContext

        const canvas = this.previewCanvasEle.current
        let rect = canvas.getBoundingClientRect()

        // we use position to check whether zoom in or zoom out
        // add small random to let user zoom out by tapping the same position.
        let smallRandom = Math.random() * 0.001
        let clickX = (event.clientX - rect.left) / canvas.width + smallRandom
        let clickY = (event.clientY - rect.top) / canvas.height + smallRandom
        updateStatus({
            clickX,
            clickY,
            zoomMode: 1,
        })

        event.stopPropagation()
    }

    toggleMotionDetection = () => {
        const {
            isMotionDetectionOn,
            changeMotionDection,
            eventAction,
        } = this.props
        return changeMotionDection(!isMotionDetectionOn, eventAction)
    }

    toggleSettingDialog = () => {
        const { toggleSettingDialog, eventAction } = this.props
        return toggleSettingDialog(eventAction)
    }

    render() {
        const {
            isPreview,
            isPaintSize,
            errorComponent,
            sourceStream,
            hideStats,
        } = this.props

        const isCameraOpen = isPreview && !errorComponent
        const showCameraStats = isCameraOpen && sourceStream && !hideStats

        return (
            <div className="camera-container">
                <div className="camera-canvas" ref={this.canvasContainerEle}>
                    <video
                        ref={this.videoEle}
                        className="camera-video"
                        playsInline
                        autoPlay
                        muted
                    />
                    {showCameraStats && this.showCameraStats()}
                    {this.state.progressValue < this.maxProgressValue && (
                        <div className="camera-loading-container">
                            <div className="camera-loading">
                                <LinearProgress
                                    className="progress"
                                    variant="determinate"
                                    value={this.state.progressValue}
                                />
                                <span className="progress-value">{`${Math.min(
                                    100,
                                    this.state.progressValue
                                )}%`}</span>
                            </div>
                        </div>
                    )}
                    <UserAlert />
                    {errorComponent}
                    <div
                        className="camera-scaled-canvas"
                        ref={this.canvasScaledContainerEle}
                    >
                        <canvas
                            ref={this.previewCanvasEle}
                            id="preview-canvas"
                            className="preview-canvas"
                        />
                        <canvas
                            id="main-canvas"
                            ref={this.mainCanvasEle}
                            className="layer-canvas"
                        />
                        <canvas
                            id="video-canvas"
                            ref={this.videoCanvasEle}
                            className="layer-canvas"
                        />
                        <canvas
                            id="box-canvas"
                            ref={this.boxCanvasEle}
                            className="box-canvas"
                        />
                        <canvas
                            id="recording-canvas"
                            ref={this.recordingCanvasEle}
                            className="layer-canvas"
                        />
                        <audio id="bg-audio" autoPlay loop>
                            <source src="/webapp/camera/white.mp3" />
                        </audio>
                    </div>
                    <CameraControls
                        key="CameraControls"
                        disabled={
                            this.props.imConnectionContext.status !== 'online'
                        }
                        isMotionOn={this.props.isMotionDetectionOn}
                        hideMotion={!!errorComponent}
                        hideSettings={this.props.hideSettings}
                        motionDisabled={this.props.controlsDisabled}
                        motionFunc={this.toggleMotionDetection}
                        motionRef={this.props.motionDetectionRef}
                        settingsFunc={this.toggleSettingDialog}
                    />
                </div>
                {isPaintSize ? this.printScreenSize() : ''}
            </div>
        )
    }
}
